/**
 * InstallAppMenuItem — Landlord
 * A menu item that triggers the PWA install prompt.
 * Visible whenever the app is installable (ignores banner cooldown).
 */

import { useInstallPrompt } from '../contexts/InstallPromptContext';

export function InstallAppMenuItem() {
  const { isInstallable, promptInstall } = useInstallPrompt();
  if (!isInstallable) return null;

  return (
    <button
      data-testid="install-app-menu-item"
      onClick={promptInstall}
      className="w-full text-left px-3 py-2 text-sm text-foreground hover:bg-accent rounded-md transition-colors"
    >
      Install App
    </button>
  );
}
